import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from '@/components/ui/collapsible';
import { SidebarNavItem } from './SidebarNavItem';
import { SubscriptionAwareSidebarItem } from './SubscriptionAwareSidebar';
import { NavItem } from './SidebarData';

interface CollapsibleToolsGroupProps {
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  items: NavItem[];
  defaultOpen?: boolean;
}

export const CollapsibleToolsGroup: React.FC<CollapsibleToolsGroupProps> = ({
  label,
  icon: Icon,
  items,
  defaultOpen = false
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  if (items.length === 0) return null;

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <CollapsibleTrigger className="flex items-center w-full px-2 py-1.5 text-sm font-medium text-muted-foreground hover:bg-accent hover:text-accent-foreground rounded-md transition-colors">
        <Icon className="h-4 w-4 mr-2 shrink-0" />
        <span className="flex-1 text-left truncate">{label}</span>
        {isOpen ? (
          <ChevronDown className="h-4 w-4 shrink-0" />
        ) : (
          <ChevronRight className="h-4 w-4 shrink-0" />
        )}
      </CollapsibleTrigger>
      <CollapsibleContent className="pl-4 space-y-1 mt-1">
        {items.map((item) => (
          <SubscriptionAwareSidebarItem
            key={item.path}
            item={item}
            isActive={false}
            onClick={() => {}}
          >
            <SidebarNavItem item={item} />
          </SubscriptionAwareSidebarItem>
        ))}
      </CollapsibleContent>
    </Collapsible>
  );
};
